import React from "react"

import ChevronDropdown from "../../../chevron-dropdown"
import ButtonFocusToggle from "../button-focus-toggle"
import * as styles from "./index.module.scss"

interface Props {
  label: React.ReactNode
  children: React.ReactNode
  "data-testid"?: string
}

const NavDropdown = ({ label, children, "data-testid": dataTestId }: Props) => {
  return (
    <ButtonFocusToggle
      containerClassName={styles.container}
      contentClassName={styles.content}
      buttonClassName={styles.button}
      emptyFocusButtonClassName={styles.emptyFocusDropdownButton}
      content={children}
      data-testid={`nav-dropdown-item-${dataTestId}`}
    >
      <div className={styles.textAndChevron}>
        <div className={styles.label}>{label}</div>
        <div className={styles.chevron}>
          <ChevronDropdown size="small" />
        </div>
      </div>
    </ButtonFocusToggle>
  )
}

export default NavDropdown
